import React from 'react';
import BillReportsHeader from '../BillReportsHeader';
import BillReportsContent from '../BillReportsContent';

const BillReports = () => {
    return (
        <>
            <BillReportsHeader />
            <BillReportsContent />
        </>
    );
};

export default BillReports;
